<template>
  <div class="w-screen lg:max-w-[calc(100vw-304px)] relative" :class="[outerWrapperClass]">
    <div :class="innerWrapperClass">
      <Placeholder name="jss-ss-main-container" :rendering="rendering" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ComponentRendering, Placeholder, ComponentFields } from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';

const props = defineProps<{
  rendering: ComponentRendering;
  fields?: ComponentFields;
}>();

const SS_STANDARD_PADDINGS = 'py-8 md:pt-15 md:pb-20';
const SS_OUTER_OFFSET = '-left-4 md:-left-8 xl:-left-25';
const SS_INNER_WRAP_CLASSES = 'px-4 md:px-8 xl:px-25 w-full md:max-w-screen xl:max-w-[1144px]';

const outerWrapperClass = computed(() => {
  const outer = props.rendering?.params?.outerOffsetClass || SS_OUTER_OFFSET;
  const background = props.rendering?.params?.backgroundClass || 'bg-racq-neutral-grey';
  return `${SS_STANDARD_PADDINGS} ${outer} ${background}`.trim();
});

//defaults to self service jss-ss-main container style layout
const innerWrapperClass = computed(() => props.rendering?.params?.innerWrapperClass || SS_INNER_WRAP_CLASSES);
</script>
